import React, { useContext } from "react";
import { Error } from "@material-ui/icons";
import { PurchaseValidationContext } from "../PurchaseValidationContext";
import MixpanelService from "../../utils/MixpanelService";

export const UnassignedWarningPanel = () => {
  const { coveredEntity340bId, identifierMappingPath } = useContext(PurchaseValidationContext);

  return (
    <div className="bg--warning p-4 mb-4 border--rounded flex gap--4 align-items-start">
      <div className="flex align-items-center justify-content-center pr-2 t--orange">
        <Error />
      </div>
      <div>
        <div className="t--md t--navyblue">
          Claims and purchases associated with identifiers that remain unassigned are added to this
          account. Review and categorize unassigned identifiers to ensure claims and purchases are
          allocated to the appropriate account.
          <br />
          <br />
          While identifiers remain unassigned, claims and purchases will continue to accrue. This
          may impact access at your covered entity’s in house pharmacy (if applicable) or contract
          pharmacy. Manage unassigned identifiers to help maintain access to pricing.
        </div>
        <div className="flex align-items-center justify-content-end pt-4">
          <a
            href={`${identifierMappingPath}?id_340b=${coveredEntity340bId}&pharmacy_group=unassigned`}
            rel="noopener noreferrer"
          >
            <button
              className="button button--white"
              onClick={() => MixpanelService.track("esp_horizon_ad_manage_identifiers")}
            >
              Manage Identifiers
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};
